import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { BehaviorSubject, catchError, concat, concatMap, delay, EMPTY, filter, finalize, mergeMap, Observable, of, retry, retryWhen, shareReplay, switchMap, take, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonService } from '../services/common.service';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
export const retryCount = environment.retryCount;
@Injectable()
export class CommonInterceptor implements HttpInterceptor {
  baseUrl: string = environment.baseUrl;
  private isTokenRefreshing: boolean = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  acct: any;
  retryTimer=environment.retryTimer;
  constructor(private commonService:CommonService,private router:Router,private authService:AuthService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Check if the user is logging in for the first time
    return next.handle(this.attachTokenToRequest(req)).pipe(
        tap((event : HttpEvent<any>) => {
            if(event instanceof HttpResponse) {}
        }),
        catchError((err) : Observable<any> => {
            if(err instanceof HttpErrorResponse) {
                switch((<HttpErrorResponse>err).status)
            {

                    case 401:
                        // console.log("Token expired. Attempting refresh ...");
                        return this.handleHttpResponseError(req, next);
                    default:
                        return this.handleRetryHttpResonse(req,next);
                }
            } else
            {
                return throwError(this.handleError);
            }
        })

    );
}

// Retrying the request when received 500 response from server
private handleRetryHttpResonse(request : HttpRequest<any>, next : HttpHandler){
        return next.handle(request).pipe(
          retryWhen(errors => concat(errors.pipe(delay(this.retryTimer), take(retryCount)), throwError(errors))
         ),
          catchError(error=>{
            this.router.navigateByUrl('/')
            this.commonService.setNotification("Error! Please try again after some time.","Error");
            return EMPTY;
          }),

        )

}

// Method to handle http error response
private handleHttpResponseError(request : HttpRequest<any>, next : HttpHandler)
{
    // First thing to check if the token is in process of refreshing
    if(!this.isTokenRefreshing)  // If the Token Refresheing is not true
    {
        this.isTokenRefreshing = true;

        // Any existing value is set to null
        // Reset here so that the following requests wait until the token comes back from the refresh token API call
        this.tokenSubject.next(null);
         /// call the API to refresh the token
         return this.commonService.getRefreshToken().pipe(
            switchMap((tokenresponse: any) => {
                if(tokenresponse.authToken)
                {
                    this.tokenSubject.next(tokenresponse.authToken.token);
                    localStorage.setItem('authToken', tokenresponse.authToken.token);
                    localStorage.setItem('RoleName', tokenresponse.authToken.roles);
                    localStorage.setItem('refreshToken', tokenresponse.authToken.refresh_token);
                    return next.handle(this.attachTokenToRequest(request));

            }
            else{
              this.commonService.setNotification("User Session Got Expired, Please Login in again", "Error");
              this.authService.logout();
              this.authService.destroyUserSession();
              window.location.reload();
            }
            }),
            catchError(err => {
                console.log(err)
                return this.handleError(err);
            }),
            finalize(() => {
              this.isTokenRefreshing = false;
            })
            );

    }
    else
    {
        this.isTokenRefreshing = false;
        return this.tokenSubject.pipe(filter(token => token != null),
            take(1),
            switchMap(token => {
            return next.handle(this.attachTokenToRequest(request));
            }));
    }

}

// Global error handler method
private handleError(errorResponse : HttpErrorResponse)
{
    console.log(errorResponse)
    let errorMsg : string;

    if(errorResponse.error instanceof Error)
    {
         // A client-side or network error occurred. Handle it accordingly.
        errorMsg = "An error occured : " + errorResponse.error.message;
    } else
    {
        // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong,
    errorMsg = `Backend returned code ${errorResponse.status}, body was: ${errorResponse.error}`;
    }

     return throwError(errorMsg);
}

private attachTokenToRequest(request: HttpRequest<any>)
{
    var token = localStorage.getItem('authToken');

    return request.clone({setHeaders: {Authorization: `Bearer ${token}`}});
}

}
